@import '~style-sheet-helpers/core.less';

.mapping-list-wrapper {
  width: 50%;
}
